module.exports = __webpack_public_path__ + "static/img/sindex_01_01.b6f184a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sindex_01_01.png
// module id = k1co
// module chunks = 1